import { gsap } from "gsap";

export default class SubscriptionTabs {
    constructor() {
        this.init();
    }

    init() {
        const subscriptionItems = gsap.utils.toArray(".subscription-item");
        subscriptionItems.forEach((item) => {
            this.setupTabs(item);
        });
    }

    setupTabs(item) {
        const navItems = item.querySelectorAll(".item_content_nav-item");
        const tabContents = item.querySelectorAll(".tab_content");

        navItems.forEach((nav) => {
            nav.addEventListener("click", (e) => {
                e.stopPropagation();
                this.toggleTabs(nav, navItems, tabContents);
            });
        });
    }

    toggleTabs(nav, navItems, tabContents) {
        const tabId = nav.getAttribute("data-tab");

        if (nav.classList.contains("active")) return;

        navItems.forEach((el) => el.classList.remove("active"));

        tabContents.forEach((content) => {
            if (!content.classList.contains("active")) return;

            gsap.to(content, {
                autoAlpha: 0,
                duration: 0.5,
                ease: "power1.inOut",
                onStart: () => {
                    content.classList.remove("active");
                    content.style.display = "none";
                },
            });
        });

        nav.classList.add("active");

        const activeContent = document.querySelector(`.tab_content[data-tab="${tabId}"]`);
        activeContent.style.display = "flex";

        gsap.to(activeContent, {
            autoAlpha: 1,
            duration: 1.5,
            ease: "power2.out",
            onStart: () => activeContent.classList.add("active"),
            onComplete: () => {
                const event = new CustomEvent("tabChanged", {
                    detail: {
                        tabId: tabId,
                    },
                });
                document.dispatchEvent(event);
            },
        });
    }
}
